import pasteIcon from './assets/icons/styled-paste.svg'
import reportIcon from './assets/icons/report.svg'
import highlightedMultiSelectIcon from './assets/icons/highlighted-multiselect.svg'
import multiSelectIcon from './assets/icons/multiselect.svg'
import unselectedList from './assets/icons/nav/unselected-list.svg'
import unselectedHome from './assets/icons/nav/unselected-home.svg'
import unselectedCalendar from './assets/icons/nav/unselected-calendar.svg'
import unselectedChat from './assets/icons/nav/unselected-chat.svg'
import unselectedEvent from './assets/icons/nav/unselected-events.svg'
import selectedList from './assets/icons/nav/selected-list.png'
import selectedHome from './assets/icons/nav/selected-home.png'
import selectedCalendar from './assets/icons/nav/selected-calendar.svg'
import selectedChat from './assets/icons/nav/selected-chat.png'
import selectedEvent from './assets/icons/nav/selected-event.png'
import folderIcon from './assets/icons/folders.svg'
import filterIcon from './assets/icons/filter.svg'
import highlightedFilterIcon from './assets/icons/highlighted-filter.svg'
import highlightedFolderIcon from './assets/icons/highlighted-folders.svg'
import copyIcon from './assets/icons/copy.svg'
import { ISOStringWithTimeZone } from './helpers/DateAndTimeHelpers'

export const STUDENT_DESTINATIONS = [
    {icon: unselectedEvent, selectedIcon: selectedEvent, path: '/events'},
    {icon: unselectedChat, selectedIcon: selectedChat, path: '/chat'},
    {icon: unselectedCalendar, selectedIcon: selectedCalendar, path: '/calendar'},
    {icon: unselectedHome, selectedIcon: selectedHome, path: '/home'},
]

export const COUNSELOR_DESTINATIONS = [
    {icon: unselectedEvent, selectedIcon: selectedEvent, path: '/events'},
    {icon: unselectedChat, selectedIcon: selectedChat, path: '/chat'},
    {icon: unselectedList, selectedIcon: selectedList, path: '/list'},
    {icon: unselectedHome, selectedIcon: selectedHome, path: '/home'},
]

export const STUDENT_SECOND_PRIORITY_DESTINATIONS = [
    {label: 'تنظیمات', path: '/settings'},
    {label: 'تحلیل آزمون', path: '/examAnalysis'},
    {label: 'برنامه هفتگی', path: '/weeklySchedule'},
    {label: 'گزارشات', path: '/report'},
    {label: 'لیگ زنده', path: '/league'},
    {label: 'آزمون ها', path: '/exams'},
    {label: 'آزمونساز مشاور', path: '/nativeExams'},
    {label: 'نشست ها', path: '/meetings'},
    // {label: 'بازی مرکب', path: '/squidGameChallenge'},
    // {label: 'آموزش اپ', path: 'https://rismanapp.info/studguide' },
]

export const COUNSELOR_SECOND_PRIORITY_DESTINATIONS = [
    {label: 'تنظیمات', path: '/settings'},
    {label: 'پرونده', path: '/file'},
    {label: 'مشاهده تحلیل', path: '/examAnalysis'},
    // {label: 'گزارشات', path: '/report'},
    {label: 'لیگ زنده', path: '/league'},
    {label: 'آزمون ها', path: '/exams'},
    {label: 'آزمونساز شخصی', path: '/nativeExams'},
    {label: 'تنظیمات کوئیز', path: '/quizDefaultSettings'},
    {label: 'نشست ها', path: '/meetings'},
    // {label: 'بازی مرکب', path: '/squidGameChallenge'},
    // {label: 'آموزش اپ', path: 'https://rismanapp.info/consguide' },
]

export const IMPORTANT_DESTINATIONS = [
    {label: 'پرونده', path: 'file'},
    {label: 'آزمونها', path: 'examAnalysis'},
    {label: 'گزارشات', path: 'report'},
    {label: 'چت', path: 'chat'}
]

export const COMPACT_STUDENTS_LIST_HEADER_OPTIONS = [
    {state: 'filter', image: filterIcon, selectedImage: highlightedFilterIcon},
    {state: 'folders', image: folderIcon, selectedImage: highlightedFolderIcon},
]

export const STUDENTS_LIST_HEADER_OPTIONS = [
    {state: 'filter', image: filterIcon, selectedImage: highlightedFilterIcon},
    {state: 'folders', image: folderIcon, selectedImage: highlightedFolderIcon},
    // {state: 'multiselect', image: multiSelectIcon, selectedImage: highlightedMultiSelectIcon}
]

export const STUDENTS_MULTISELECT_LIST_HEADER_OPTIONS = [
    {state: 'multiselect', image: multiSelectIcon, selectedImage: highlightedMultiSelectIcon},
    {state: 'folders', image: folderIcon, selectedImage: highlightedFolderIcon},
    {state: 'report', image: reportIcon, selectedImage: reportIcon, intactUrl: true}
]

export const COUNSELOR_PLANNER_LIST_HEADER_OPTIONS = [
    {image: copyIcon, selectedImage: copyIcon, intactUrl: true, state: 'copy'},
    {image: pasteIcon, selectedImage: pasteIcon, intactUrl: true, state: 'paste'},
]

export const STUDENT_PLANNER_LIST_HEADER_OPTIONS = [
    {image: pasteIcon, selectedImage: pasteIcon, intactUrl: true, state: 'paste'},
]

export const THEMES = [
    {label: 'ice', background: `var(--default-gradient-background)`},
    {label: 'sunny', background: `var(--sunny-gradient-background)`},
    {label: 'patterned-ice', background: `url(/pattern.png), var(--default-gradient-background)`},
    {label: 'patterned-sunny', background: ` url('/pattern.png'), var(--sunny-gradient-background)`},
]

export const STUDY_LEAGUE_BACKGROUND = [
    'linear-gradient(#FFF5D2, #EFCB4A)',
    'linear-gradient(#F5F5F5, #B1B1B1)',
    'linear-gradient(#FCEED9, #E09945)'   
]

export const WAKING_LEAGUE_BACKGROUND = [
    'url(/dawn.svg)',
    'url(/morning.svg)',
    'url(/noon.svg)',
]

export const QUICK_ACCESS_OPTIONS = [
    { label: 'چت', path: 'chat' },
    { label: 'گزارش', path: 'report' },
    { label: 'پرونده', path: 'file' },
    { label: 'تحلیل آزمون', path: 'examAnalysis' },
    { label: 'برنامه دادن', path: '' },
    { label: 'جلسه فوری', path: 'meeting' },
    { label: 'گزارش پیامکی به اولیا', path: 'secondaryNumber' },
    { label: 'حذف دانش آموز', path: 'remove' }
]

export const BANNER_PLACEHOLDER = { image: '/pattern.png', mini_image_link: '/pattern.png', title: '', dominant_color: '' }

export const FILTER_KEYWORDS = [
    {label: 'ششم', key: 'filter-grade', value: '10', color: 'پایه'},
    {label: 'هفتم', key: 'filter-grade', value: '1', color: 'پایه'},
    {label: 'هشتم', key: 'filter-grade', value: '2', color: 'پایه'},
    {label: 'نهم', key: 'filter-grade', value: '3', color: 'پایه'},
    {label: 'دهم', key: 'filter-grade', value: '4', color: 'پایه'},
    {label: 'یازدهم', key: 'filter-grade', value: '5', color: 'پایه'},
    {label: 'دوازدهم', key: 'filter-grade', value: '6', color: 'پایه'},

    {label: 'ریاضی', key: 'filter-major', value: '1', color: 'رشته'},
    {label: 'تجربی', key: 'filter-major', value: '2', color: 'رشته'},
    {label: 'انسانی', key: 'filter-major', value: '3', color: 'رشته'},

    {label: 'فعال', key: 'filter-active', value: 'true', color: 'فعال'},
    {label: 'غیرفعال', key: 'filter-active', value: 'false', color: 'فعال'}
]

export const LEAGUE_FILTER_KEYWORDS = [
    {label: 'ششم', key: 'league-grade', value: '10', color: '#EDEDED'},
    {label: 'هفتم', key: 'league-grade', value: '1', color: '#EDEDED'},
    {label: 'هشتم', key: 'league-grade', value: '2', color: '#EDEDED'},
    {label: 'نهم', key: 'league-grade', value: '3', color: '#EDEDED'},
    {label: 'دهم', key: 'league-grade', value: '4', color: '#EDEDED'},
    {label: 'یازدهم', key: 'league-grade', value: '5', color: '#EDEDED'},
    {label: 'دوازدهم', key: 'league-grade', value: '6', color: '#EDEDED'},

    {label: 'ریاضی', key: 'league-major', value: '1', color: '#EDEDED'},
    {label: 'تجربی', key: 'league-major', value: '2', color: '#EDEDED'},
    {label: 'انسانی', key: 'league-major', value: '3', color: '#EDEDED'}
]

export const COUNSELOR_TOOLS = [
    {label: 'افزودن کوئیزها', value: '1', key: 'با یک کلیک کوئیزهای مربوط به تمام آیتم های درسی امروز را فعال کنید. این ویژگی در حالت غیرفعال کردن همه کوئیزها به صورت پیشفرض بسیار کاربردی است'},
    {label: 'افزودن روزخوانی', value: '2', key: 'با یک کلیک آیتم های مربوط به مرور درس امروز مدرسه را (با توجه به برنامه هفتگی دانش آموز) فعال کنید. استفاده از این ویژگی مستلزم وارد کردن برنامه هفتگی توسط دانش آموز است'},
    {label: 'افزودن درس فردا', value: '3', key: 'با یک کلیک آیتم های مربوط به مرور درس فردای مدرسه را(با توجه به برنامه هفتگی دانش آموز) فعال کنید. استفاده از این ویژگی مستلزم وارد کردن برنامه هفتگی توسط دانش آموز است'},
    {label: 'افزودن روتین', value: '4', key: 'روتین های شبانه یا هر مورد تکرار شونده دیگر را به راحتی در روزهای متعدد قرار دهید. استفاده از این قابلیت بسیار راحت تر از کپی پیست موارد می باشد'},
]

export const STUDY_METHODS = [
    {label: 'خلاصه برداری', value: '0'},
    {label: 'مرور', value: '1'},
    {label: 'فیلم آموزشی', value: '2'},
    {label: 'فلش کارت', value: '3'},
    {label: 'پیشخوانی', value: '4'},
    {label: 'سوال تشریحی', value: '5'},
    {label: 'روزخوانی', value: '6'},
]

export const TEST_METHODS = [
    {label: 'آموزشی', value: '0'},
    {label: 'سنجشی', value: '1'},
    {label: 'زماندار', value: '2'},
    {label: 'آزمون مشابه پارسال', value: '3'},
]

export const LEAGUE_TYPES = [
    {label: 'لیگ مطالعه', value: '1', key: 'timeData'},
    {label: 'لیگ تست', value: '2', key: 'testData'},
    {label: 'لیگ صبحگاهی', value: '3', key: 'wakingData'}
]

export const EXAM_TYPES = [
    {label: 'قلمچی', value: 'قلمچی'},
    {label: 'ماز', value: 'ماز'},
    {label: 'گزینه دو', value: 'گزینه دو'}
]

export const reasons = [
    {label: 'بلد نبودم', value: 0, group: 'ضعف دانش'},
    {label: 'نداشتن ایده حل', value: 1, group: 'ضعف دانش'},
    {label: 'به بودجه نرسیدم', value: 2, group: 'ضعف دانش'},
    {label: 'شک داشتم', value: 3, group: 'ضعف دانش'},
    {label: 'اشتباه محاسباتی', value: 4, group: 'ضعف تمرکز'},
    {label: 'اشتباه خواندن صورت', value: 5, group: 'ضعف تمرکز'},
    {label: 'جا به جا وارد کردن', value: 6, group: 'ضعف تمرکز'},
    {label: 'نرسیدم و بلد بودم', value: 7, group: 'ضعف سرعت عمل'},
    {label: 'نرسیدم و بلد نبودم', value: 8, group: 'ضعف سرعت عمل'},
    {label: 'سوال غلط بود', value: 9, group: 'سایر'},
    {label: 'خارج از بودجه آزمون', value: 10, group: 'سایر'}
]

export const weekDays = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه']

export const SEX = [
    { label: 'مرد', value: '1' }, 
    { label: 'زن', value: '2' }
]

export const REACTIONS = [
    'آفرین عزیزم',
    '👌❤️',
    'درود به شرفت',
    'خسته نباشی',
    'گزارشت عزیزم',
]

export const EXAM_DIFFICULTY_LEVELS = [
    { label: 'آسان', value: 'easy', color: 'green' },
    { label: 'متوسط', value: 'medium', color: 'gold' },
    { label: 'سخت', value: 'hard', color: 'red' },
    { label: 'بسیار سخت', value: 'veryHard', color: 'darkred' },
]

export const FILE_TYPES = [
    {label: 'یادداشت', type: 0, value: 'notes'},
    {label: 'تماس با دانش آموز', type: 1, value: 'calls'},
    {label: 'تماس با اولیا', type: 2, value: 'parentCalls'},
    {label: 'جلسه حضوری', type: 3, value: 'meetings'}
]

export const INTERVAL_COMPLETION_TYPES = [
    {label: 'دقیقا درون بازه', value: '1', color: '#00FF00'},
    {label: 'قبل از شروع بازه یا بعد از پایان آن', value: '2', color: '#0000FF'},
    {label: 'عدم انجام', value: '3', color: '#FF0000'},
    {label: 'اضافه شده', value: '4', color: '#FFA500'},
]

export const STUDENT_NON_STUDY_INTERVALS = [
    {label: 'کلاس آنلاین', value: 'کلاس آنلاین'},
    {label: 'کلاس آفلاین', value: 'کلاس آفلاین'},
    {label: 'خواب', value: 'خواب'},
    {label: 'ورزش', value: 'ورزش'},
    {label: 'هنر', value: 'هنر'},
    {label: 'سینما', value: 'سینما'},
    {label: 'رسانه', value: 'رسانه'}
]

export const COUNSELOR_NON_STUDY_INTERVALS = [
    {label: 'جلسه با مدیر', value: 'جلسه با مدیر'},
    {label: 'جلسه مشاوره', value: 'جلسه مشاوره'},
    {label: 'تماس با دانش آموز', value: 'تماس با دانش آموز'},
    {label: 'تماس با اولیا', value: 'تماس با اولیا'},
    {label: 'مطالعه', value: 'مطالعه'},
    {label: 'ورزش', value: 'ورزش'},
]

export const MAP_PERSIAN_TO_ENGLISH = {
    'ا' : 'a',
    'آ' : 'u',
    'ب' : 'b',
    'پ' : 'p',
    'ت' : 't',
    'ث' : 'th',
    'ج' : 'j',
    'چ' : 'ch',
    'ح' : 'h',
    'خ' : 'kh',
    'د' : 'd',
    'ذ' : 'z',
    'ر' : 'r',
    'ز' : 'z',
    'ژ' : 'zh',
    'س' : 's',
    'ش' : 'sh',
    'ص' : 's',
    'ض' : 'z',
    'ط' : 't',
    'ظ' : 'z',
    'ف' : 'f',
    'ق' : 'gh',
    'ک' : 'k',
    'گ' : 'g',
    'ل' : 'l',
    'م' : 'm',
    'ن' : 'n',
    'و' : 'o',
    'ه' : 'h',
    'ی' : 'y',
}

export const DESKTOP_PLANNER_STEPS = [
    { selector: 'list', message: 'با کلیک روی یک دانش آموز او را انتخاب کنید', height: 60, scrollMotion: true, width: 250 }, 
    { selector: 'calendar-nav', message: 'روی حالت جدولی تقویم کلیک کنید', clickSelector: 'table-calendar', height: 80, specificClick: true }, 
    { selector: ISOStringWithTimeZone(), message: 'روی یک باکس روز مد نظر کلیک کنید', clickSelector: ISOStringWithTimeZone() + '-0', height: 80, viewOnly: true },
    { selector: 'planner-types-nav', message: 'می توانید نوع مورد پلنر را مشخص کنید', height: 80, leftOffset: -75, width: 250, viewOnly: true },
    { selector: 'lessons-picker-planner', message: 'درس موردنظر را انتخاب کنید', withoutPreviousButton: true, leftOffset: -100 },
    { selector: 'list-lessons-picker-planner', message: 'درس موردنظر را انتخاب کنید', looseSelectionId: 'item-lesson', withoutPreviousButton: true },
    { selector: 'topics-picker-planner', message: 'مبحث موردنظر را انتخاب کنید', withoutPreviousButton: true, leftOffset: -100 },
    { selector: 'area-topics-picker-planner', message: 'مبحث موردنظر را انتخاب کنید', clickSelector: 'closure-area-topics-picker-planner', specificClick: true, withoutPreviousButton: true },
    { selector: 'approval-add-planner-item', message: 'درنهایت با زدن دکمه تیک مورد را ثبت کنید', clickSelector: 'approval-add-planner-item', specificClick: true, leftOffset: -20, width: 250, withoutPreviousButton: true }
]

export const MOBILE_DASHBOARD_STEPS = [
    { selector: 'noplan', clickSelector: 'noplan', message: 'این بخش تعداد گزارشات ثبت شده امروز و تعداد دانش آموزانی که گزارش نداده اند را نشان میدهد', height: 150, width: 240, leftOffset: -100, viewOnly: true }, 
    { selector: 'footer-noplan', message: 'تعداد دانش آموزانی که امروز گزارش ثبت کرده اند و درصدشان نسبت به کل دانش آموزان. با کلیک روی این بخش لیست این دانش آموزان را می بینید', height: 150, width: 229, leftOffset: -100, viewOnly: true }, 
    { selector: '1-noplan', message: 'با کلیک روی هر ستون، لیست دانش آموزانی که در بازه زمانی مشخص شده گزارش نداده اند را می بینید', height: 150, width: 223, viewOnly: true }, 
    { selector: 'time', clickSelector: 'time', message: 'در این بخش جزئیات عملکرد مطالعه دانش آموزانتان را می بینید', height: 150, width: 240, leftOffset: -180, viewOnly: true }, 
    { selector: 'footer-time', message: 'میانگین زمان مطالعه امروز دانش آموزان شما؛ نوار پایینی نسبت مطالعه میانگین به زمان میانگین برنامه ارائه شده را نشان می دهد', height: 150, width: 234, leftOffset: -180, viewOnly: true }, 
    { selector: '1-time', message: 'میانگین زمان مطالعه هفت روز اخیر دانش آموزان شما؛ نمودار ستونی نسبت مطالعه میانگین به زمان میانگین برنامه های ارائه شده را نشان می دهد', height: 150, width: 231, leftOffset: -180, viewOnly: true }, 
    { selector: 'test', clickSelector: 'test', message: 'در این بخش جزئیات عملکرد تست دانش آموزانتان را می بینید', height: 150, width: 240, leftOffset: -30, viewOnly: true }, 
    { selector: 'footer-test', message: 'میانگین تست امروز دانش آموزان شما؛ نوار پایینی نسبت عملکرد تست میانگین به تعداد تست میانگین برنامه های ارائه شده را نشان می دهد', height: 170, width: 200, leftOffset: -30, viewOnly: true }, 
    { selector: '1-test', message: 'میانگین تست هفت روز اخیر دانش آموزان شما؛ نمودار ستونی نسبت عملکرد میانگین تست به تعداد تست میانگین برنامه های ارائه شده را نشان می دهد', height: 170, width: 200, leftOffset: -30, viewOnly: true }, 
    { selector: 'mobile-league', clickSelector: 'mobile-league', message: 'برترین دانش آموزان امروز از نظر مطالعه و تست. با کلیک روی این بخش به صفحه لیگ با جزئیات بیشتر هدایت می شوید', height: 150, width: 240, leftOffset: -150, viewOnly: true }, 
    { selector: 'tools', clickSelector: 'tools', message: 'در این بخش عملیات های گروهی پیچیده به صورت مرحله به مرحله ساده سازی شده اند. با کلیک روی هر یک راهنمایی کامل برای تکمیل عملیات در اختیار شما قرار می گیرد ', height: 150, width: 240, leftOffset: -150, viewOnly: true }, 
]

export const DESKTOP_DASHBOARD_STEPS = [
    { selector: 'noplan', clickSelector: 'noplan', message: 'این بخش تعداد گزارشات ثبت شده امروز و تعداد دانش آموزانی که گزارش نداده اند را نشان میدهد', height: 150, width: 240, leftOffset: -100, viewOnly: true }, 
    { selector: 'footer-noplan', message: 'تعداد دانش آموزانی که امروز گزارش ثبت کرده اند و درصدشان نسبت به کل دانش آموزان. با کلیک روی این بخش لیست این دانش آموزان را می بینید', height: 150, width: 229, leftOffset: -100, viewOnly: true }, 
    { selector: '1-noplan', message: 'با کلیک روی هر ستون، لیست دانش آموزانی که در بازه زمانی مشخص شده گزارش نداده اند را می بینید', height: 150, width: 223, viewOnly: true }, 
    { selector: 'time', clickSelector: 'time', message: 'در این بخش جزئیات عملکرد مطالعه دانش آموزانتان را می بینید', height: 150, width: 240, leftOffset: -180, viewOnly: true }, 
    { selector: 'footer-time', message: 'میانگین زمان مطالعه امروز دانش آموزان شما؛ نوار پایینی نسبت مطالعه میانگین به زمان میانگین برنامه ارائه شده را نشان می دهد', height: 150, width: 234, leftOffset: -180, viewOnly: true }, 
    { selector: '1-time', message: 'میانگین زمان مطالعه هفت روز اخیر دانش آموزان شما؛ نمودار ستونی نسبت مطالعه میانگین به زمان میانگین برنامه های ارائه شده را نشان می دهد', height: 150, width: 231, leftOffset: -180, viewOnly: true }, 
    { selector: 'test', clickSelector: 'test', message: 'در این بخش جزئیات عملکرد تست دانش آموزانتان را می بینید', height: 150, width: 240, leftOffset: -30, viewOnly: true }, 
    { selector: 'footer-test', message: 'میانگین تست امروز دانش آموزان شما؛ نوار پایینی نسبت عملکرد تست میانگین به تعداد تست میانگین برنامه های ارائه شده را نشان می دهد', height: 170, width: 200, leftOffset: -30, viewOnly: true }, 
    { selector: '1-test', message: 'میانگین تست هفت روز اخیر دانش آموزان شما؛ نمودار ستونی نسبت عملکرد میانگین تست به تعداد تست میانگین برنامه های ارائه شده را نشان می دهد', height: 170, width: 200, leftOffset: -30, viewOnly: true }, 
    { selector: 'desktop-league', clickSelector: 'desktop-league', message: 'برترین دانش آموزان امروز از نظر مطالعه و تست. با کلیک روی این بخش به صفحه لیگ با جزئیات بیشتر هدایت می شوید', height: 150, width: 240, leftOffset: -150, viewOnly: true }, 
    { selector: 'tools', clickSelector: 'tools', message: 'در این بخش عملیات های گروهی پیچیده به صورت مرحله به مرحله ساده سازی شده اند. با کلیک روی هر یک راهنمایی کامل برای تکمیل عملیات در اختیار شما قرار می گیرد ', height: 150, width: 240, leftOffset: -150, viewOnly: true }, 
]

export const STUDENT_PLANNER = [
    { selector: 'navbar', message: 'به صفحه تقویم بروید', clickSelector: '/calendar', height: 80, leftOffset: -100, specificClick: true }, 
    { selector: 'calendar-nav', message: 'روی حالت هفتگی تقویم کلیک کنید', clickSelector: 'weekly-calendar', height: 80, leftOffset: -100, specificClick: true }, 
    { selector: 'weekly-' + ISOStringWithTimeZone(), message: 'روی روز مدنظر کلیک کنید', clickSelector: 'weekly-' + ISOStringWithTimeZone(), height: 80, leftOffset: -150, viewOnly: true },
    { selector: 'plus-plan', clickSelector: 'plus-button', message: 'برای ایجاد مورد جدید کلیک کنید', withoutPreviousButton: true, leftOffset: -60, preventScroll: true, specificClick: true },
    { selector: 'planner-types-nav', clickSelector: 'مطالعه', message: 'می توانید نوع مورد پلنر را مشخص کنید', height: 80, leftOffset: -120, topOffset: 150, withoutChevron: true, width: 250, specificClick: true, withoutPreviousButton: true },
    { selector: 'lessons-picker-planner', clickSelector: 'lessons-picker-planner', message: 'درس موردنظر را انتخاب کنید', leftOffset: -150, preventScroll: true, viewOnly: true, specificClick: true },
    { selector: 'list-lessons-picker-planner', message: 'درس موردنظر را انتخاب کنید', looseSelectionId: 'item-lesson', withoutPreviousButton: true, leftOffset: -150, preventScroll: true },
    { selector: 'topics-picker-planner', clickSelector: 'topics-picker-planner', message: 'مبحث موردنظر را انتخاب کنید', withoutPreviousButton: true, leftOffset: -100, preventScroll: true, viewOnly: true, specificClick: true },
    { selector: 'area-topics-picker-planner', message: 'مبحث موردنظر را انتخاب کنید', clickSelector: 'closure-area-topics-picker-planner', leftOffset: -150, specificClick: true, withoutPreviousButton: true, preventScroll: true },
    { selector: 'approval-add-planner-item', message: 'درنهایت با زدن دکمه تیک مورد را ثبت کنید', clickSelector: 'approval-add-planner-item', specificClick: true, leftOffset: -50, width: 250, withoutPreviousButton: true, preventScroll: true },
    { selector: 'right-planner-item-0', message: 'با کلیک روی بخش راست هر تسک، جزئیات آن را مشاهده کنید', height: 80, leftOffset: -150, viewOnly: true, withoutChevron: true, withoutPreviousButton: true, preventScroll: true }, 
    { selector: 'checkbox-left-planner-item-0', message: 'با زدن تیک، انجام کامل تسک را اعلام کنید', clickSelector: 'checkbox-left-planner-item-0', height: 80, leftOffset: -30, specificClick: true, viewOnly: true, withoutChevron: true, preventScroll: true }, 
    { selector: 'left-planner-item-0', message: 'برای اعلام ناقصی انجام تسک یا وارد کردن جزئیات بیشتر کلیک کنید', clickSelector: 'left-planner-item-0', height: 80, leftOffset: -70, specificClick: true, viewOnly: true, withoutChevron: true, preventScroll: true }, 
]

export const STUDENT_DASHBOARD = [
    { selector: 'student-dashboard-planner', clickSelector: 'student-dashboard-planner', message: 'دسترسی سریع به برنامه امروز؛ شما می توانید با زدن دکمه انجام شد، تکمیل یک تسک را اعلام کنید', height: 150, width: 240, leftOffset: -100, viewOnly: true, preventScroll: true }, 
    { selector: 'time', clickSelector: 'time', message: 'در این بخش مجموع عملکرد مطالعه هفتگی و ماهانه خود را مشاهده می کنید', height: 150, width: 240, leftOffset: -180, viewOnly: true }, 
    { selector: 'footer-time', message: 'مجموع مطالعه شما از روز شنبه هفته جاری؛ نوار زیر نشان دهنده میزان تکمیل برنامه مشاور در همین بازه می باشد' , height: 150, width: 234, leftOffset: -180, viewOnly: true }, 
    { selector: '1-time', message: 'مجموع مطالعه شما از روز یکم ماه جاری؛ نمودار ستونی نشان دهنده میزان تکمیل برنامه در همین بازه می باشد', height: 150, width: 231, leftOffset: -180, viewOnly: true }, 
    { selector: 'test', clickSelector: 'test', message: 'در این بخش مجموع عملکرد تست هفتگی و ماهانه خود را مشاهده می کنید', height: 150, width: 240, leftOffset: -30, viewOnly: true }, 
    { selector: 'footer-test', clickSelector: 'footer-test', message: 'مجموع تست شما از روز شنبه هفته جاری؛ نوار زیر نشان دهنده میزان تکمیل برنامه مشاور در همین بازه می باشد' , height: 150, width: 234, leftOffset: -80, viewOnly: true }, 
    { selector: '1-test', message: 'مجموع تست شما از روز یکم ماه جاری؛ نمودار ستونی نشان دهنده میزان تکمیل برنامه در همین بازه می باشد', height: 150, width: 231, leftOffset: -80, viewOnly: true }, 
    { selector: 'tools', clickSelector: 'tools', message: 'شما می توانید از بخش ابزارها با کلیدهای میانبر به کرونومتر، صفحه پلنر و تحلیل آزمون دسترسی داشته باشید', height: 150, width: 240, leftOffset: -150, viewOnly: true }
]

export const STUDENT_EXAM_ANALYSIS = [
    { selector: 'add-analysis', clickSelector: 'add-analysis', message: 'برای ایجاد تحلیل آزمون جدید کلیک کنید', leftOffset: -150, preventScroll: true, specificClick: true },
    { selector: 'analysis-inputs', message: 'در این بخش عنوان آزمون، تعداد کل سوالات و تراز را وارد کنید. امکان ویرایش تعداد غلط ها و نزده ها وجود ندارد چرا که با توجه به تحلیل شمرده می شوند', viewOnly: true, preventScroll: true, withoutChevron: true, leftOffset: -100, topOffset: 320, height: 150 },
    { selector: 'add-lesson-analysis', clickSelector: 'add-lesson-analysis', message: 'برای افزودن درس به تحلیل کلیک کنید', leftOffset: -100, preventScroll: true, specificClick: true },
    { selector: 'analysis-lesson-picker', clickSelector: 'analysis-lesson-picker', message: 'درس موردنظر را انتخاب کنید', leftOffset: -150, preventScroll: true, viewOnly: true, specificClick: true, withoutChevron: true, topOffset: 150 },
    { selector: 'list-analysis-lesson-picker', message: 'درس موردنظر را انتخاب کنید', looseSelectionId: 'item-analysis', withoutPreviousButton: true, leftOffset: -150, preventScroll: true },
    { selector: 'analysis-questions-interval', message: 'در این بخش بازه سوالات درس مورد نظر در آزمون را وارد می کنید. مثلا از 10 تا 20' , viewOnly: true, preventScroll: true, withoutChevron: true, leftOffset: -150, topOffset: 200, height: 150 },
    { selector: 'question-10', message: 'وضعیت هر سوال رو با کلیک روی غلط یا نزده مشخص کنید', looseSelectionId: 'state', leftOffset: -150, height: 100 },
    { selector: 'question-10', clickSelector: 'question-10', specificClick: true, message: 'دلیل اشتباه خود را با کلیک روی «دلیل؟» مشخص کنید', leftOffset: -150, height: 100 },
    { selector: 'reason-picker', message: 'می توانید دلیل اشتباه خود را وارد کنید یا از لیست انتخاب کنید. همچنین می توانید مبحث این سوال را مشخص کنید. در نهایت با زدن تیک، تغییرات خود را ثبت کنید', clickSelector: 'approval-reason-picker', leftOffset: -150, height: 160, specificClick: true, withoutPreviousButton: true, preventScroll: true },
    { selector: 'approval-question-picker', clickSelector: 'approval-question-picker', message: 'با زدن تیک، تحلیل آزمون درس انتخاب شده را ثبت کنید', topOffset: 150, specificClick: true, withoutChevron: true, withoutPreviousButton: true, preventScroll: true },
    { selector: 'send-analysis', clickSelector: 'send-analysis', message: 'پس از وارد کردن تمام دروس آزمون به طریق مشابه، با زدن ارسال تحلیل خود را ثبت کنید', leftOffset: -150, preventScroll: true, specificClick: true },
]

export const DEFAULT_PROFILE_PIC = "https://api.risman.app/storage/images/r50tu4PWFY.png"

export const CHAT_BASE_URL = 'https://chat.risman.app/api/v1/';
export const CHAT_WS_URL = "wss://chat.risman.app/ws/v1/"
